import { useMemo } from 'react';

import { appendInputIdToLabel } from 'utils';
import { defaultLanguage, useTranslationContext } from 'context';

import { InputField, DatePickerField } from '../fields';

import { FormInputFieldProps } from './types';

export const FormInputField = ({
  id,
  label,
  inputId,
  options,
  expandable,
  placeholder,
  translations,
  labelOutside = true,
}: FormInputFieldProps) => {
  const isNumber = options?.type === 'number';
  const isMultiline = options?.multiline;
  const { language } = useTranslationContext();

  const translation = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return {
        placeholder,
        label: appendInputIdToLabel(label, inputId),
      };
    }

    const translation = translations[language];
    return {
      placeholder: translation?.placeholder || placeholder,
      label: appendInputIdToLabel(
        label ? translation?.label || label : label,
        inputId
      ),
    };
  }, [label, placeholder, language, translations, inputId]);

  if (options?.type === 'date') {
    return (
      <DatePickerField
        name={id}
        hideFormatText
        label={translation.label}
        labelOutside={labelOutside}
        placeholder={translation.placeholder}
      />
    );
  }

  return (
    <InputField
      name={id}
      fullWidth
      multiline={isMultiline}
      label={translation.label}
      labelOutside={labelOutside}
      placeholder={translation.placeholder}
      expandable={isMultiline && expandable}
      type={isNumber ? 'text' : options?.type}
      inputMode={isNumber ? 'numeric' : undefined}
      pattern={
        isNumber ? (options?.integer ? '[^0-9]' : '[^0-9.-]') : undefined
      }
    />
  );
};
